import { getInstance } from './authWrapper';
import store from '../store';
export const authGuard = (to, from, next) => {
  const authService = getInstance();

  const fn = async () => {
    // If the user is authenticated, continue with the route
    if (authService.isAuthenticated) {
      let dealer = await store.dispatch('orders/getDealerFromEmail');
      if (
        !dealer ||
        !['DirectSales', 'Admin', 'Dealer', 'Employee'].includes(
          dealer.authLevel
        )
      ) {
        return next('/unauthorized');
      }
      return next();
    }

    // Otherwise, log in
    authService.loginWithRedirect({
      appState: { targetUrl: to.fullPath },
      scope: 'openid profile email roles',
    });
  };

  // If loading has already finished, check our auth state using `fn()`
  if (!authService.loading) {
    return fn();
  }

  // Watch for the loading property to change before we check isAuthenticated
  authService.$watch('loading', (loading) => {
    if (loading === false) {
      return fn();
    }
  });
};
